import { render, staticRenderFns } from "./bind_parent_mobile.vue?vue&type=template&id=33bedfa8&scoped=true"
import script from "./bind_parent_mobile.vue?vue&type=script&lang=js"
export * from "./bind_parent_mobile.vue?vue&type=script&lang=js"
import style0 from "./bind_parent_mobile.vue?vue&type=style&index=0&id=33bedfa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_16d71e7cf8bf5c3e53d15d26d70867ca/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bedfa8",
  null
  
)

export default component.exports